import { Card } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

import { ReactBlocks } from 'app/helpers/Blocks'

export interface IAttributes {
  centered: boolean
  withPaddings: boolean
}

const CardBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <ReactBlocks
      innerBlocks={props.innerBlocks}
      render={(blocks) => (
        <Card
          {...attributes}
          contentDir="row"
          contentWidth="100%"
          withoutPadding={attributes.withPaddings === false ? true : undefined}
        >
          <div>
            {attributes.centered ? (
              <FlexWrapperView>{blocks}</FlexWrapperView>
            ) : (
              <NonFlexWrapperView>{blocks}</NonFlexWrapperView>
            )}
          </div>
        </Card>
      )}
    />
  )
}

const FlexWrapperView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  text-align: center;
`

const NonFlexWrapperView = styled.div`
  box-sizing: border-box;
`

export default CardBlock
